import { IconButton, Tooltip } from "@mui/material";
import type { ReactNode } from "react";
import { NAV_BAR_COLORS } from "../nav-bar-constant";

export interface NavBarIconButtonProps {
  title: string;
  children: ReactNode;
  onClick?: () => void;
}

/** Ghost icon button tinted for the brand-blue bar, labelled by its tooltip. */
const NavBarIconButton = ({
  title,
  children,
  onClick,
}: NavBarIconButtonProps) => (
  <Tooltip title={title}>
    <IconButton
      size="small"
      aria-label={title}
      sx={{ color: NAV_BAR_COLORS.ON_BAR }}
      onClick={onClick}
    >
      {children}
    </IconButton>
  </Tooltip>
);

export default NavBarIconButton;
